export default {
    TECNICO_EM_SAUDE_BUCAL: '322405',
    TECNICO_EM_SAUDE_BUCAL_ESF: '322425',
    AUXILIAR_EM_SAUDE_BUCAL: '322415',
    AUXILIAR_EM_SAUDE_BUCAL_ESF: '322430',
    TECNICO_EM_AGENTE_COMUNITARIO_DE_SAUDE: '322255',
    AGENTE_COMUNITARIO_DE_SAUDE: '515105',
}
